import ForgotPasswordPage, { ForgotPasswordPageProps } from './ForgotPasswordPage';

export type { ForgotPasswordPageProps };
export default ForgotPasswordPage;
